import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./headerEnquires.css";
import ListProjectsAdmin from "../Enquiry/listProjectsAdmin";
import ListEnquiries from "../Enquiry/listEnquiries";
import UserEnquiries from "../Enquiry/userEnquires";
import { Skeleton } from "antd";

const STORAGE_KEY = "enquiry_header_tab";

const EnquiresHeader = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "project-enquiry"
  );

  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "project-enquiry" ? "clicked" : ""}
              onClick={() => handleTableSelection("project-enquiry")}
            >
              Project List
            </h4>
            <h4
              className={selectedTable === "interested-project" ? "clicked" : ""}
              onClick={() => handleTableSelection("interested-project")}
            >
              Interested Project
            </h4>
            <h4
              className={selectedTable === "userEnquiry" ? "clicked" : ""}
              onClick={() => handleTableSelection("userEnquiry")}
            >
              User Enquiry
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "project-enquiry" ? "block" : "none" }}>
            <ListProjectsAdmin />
          </div>

          <div style={{ display: selectedTable === "interested-project" ? "block" : "none" }}>
            <ListEnquiries />
          </div>

          <div style={{ display: selectedTable === "userEnquiry" ? "block" : "none" }}>
            <UserEnquiries />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EnquiresHeader;
